import { Button, Select } from 'antd'
import EmailCont from '../../../components/Common/Email/EmailCont'
import DateCell from '../../../elements/Table/Cells/DateCell'
import StatusCell from '../../../elements/Table/Cells/StatusCell'
import CustomTable from '../../../elements/Table/CustomTable'
import React, { Fragment } from 'react'
import { Link, withRouter } from 'react-router-dom'
import checkboxHOC from 'react-table-v6/lib/hoc/selectTable'
import { compose, withState } from 'recompose'
import OrganisationsSelect from '../../../elements/Select/Organistaions'
import Status from '../../../elements/Status'
import { formatQueryParams, idMaker, moneyColumn } from '../../../modules/Utils'

const CheckboxTable = checkboxHOC(CustomTable)

const ids = idMaker()
export const columns = [
  {
    Header: 'Code',
    accessor: 'code',
    width: 150,
    Cell: ({ original, value }) => (
      <Link
        to={{
          pathname: `/clients/quotes/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),
  },
  {
    Header: 'Enquiry',
    accessor: 'enquiry.code',
    width: 150,
    hideable: true,
    hideDefault: false,
    /*Cell: ({original, value}) => (
      <Link
        to={{
          pathname: `/clients/enquiries/${original._key}/update`,
        }}>
        {value}
      </Link>
    ),*/
  },
  {
    Header: 'Date',
    accessor: 'date',
    Cell: DateCell,
    width: 100,
  },
  {
    Header: 'Valid Till',
    accessor: 'validity.date',
    Cell: DateCell,
    width: 100,
  },
  {
    Header: 'Activity',
    accessor: 'quoteType',
    width: 100,
  },
  {
    Header: 'Title',
    accessor: 'title',
    style: { alignment: 'left', marginLeft: 10 },
    hideable: true,
  },
  {
    Header: 'Client',
    accessor: 'enquirer.fn',
    width: 350,
  },
  {
    Header: 'Currency',
    accessor: 'currency',
    style: { textAlign: 'center' },
    hideable: true,
    hideDefault: false,
    width: 100,
  },
  {
    Header: 'Amount (EX)',
    accessor: 'subTotal.net',
    style: { textAlign: 'right' },
    Cell: ({ value }) => moneyColumn(value),
    hideable: true,
    hideDefault: false,
    width: 100,
  },
  {
    Header: 'Amount (INC)',
    accessor: 'subTotal.gross',
    style: { textAlign: 'right' },
    Cell: ({ value }) => moneyColumn(value),
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Company',
    accessor: 'company.fn',
    width: 350,
    hideable: true,
    hideDefault: true,
  },
  {
    Header: 'Status',
    accessor: 'status',
    width: 150,
    Cell: StatusCell,
    filterMethod: (filter, row) => {
      const activeArray = ['Confirmed', 'Revised', 'Draft','Expired']
      const expiredArray = ['Expired']
      const draftArray = ['Draft']
      const revisedArray = ['Revised']
      const nonActiveArray = ['Closed', 'Delivered', 'Cancelled']
      if (filter.value === 'all') {
        return true
      }
      if (filter.value === 'draft') {
        return draftArray.includes(row[filter.id])
      }
      if (filter.value === 'revised') {
        return revisedArray.includes(row[filter.id])
      }
      if (filter.value === 'expired') {
        return expiredArray.includes(row[filter.id])
      }
      return filter.value === true ? activeArray.includes(row[filter.id]) : nonActiveArray.includes(row[filter.id])
    },
    Filter: ({ onChange, filter }) => (
      <Select onChange={(value) => onChange(value)} style={{ width: '100%' }} value={filter ? filter.value : 'all'}>
        <Select.Option value="all">All</Select.Option>
        <Select.Option value={'draft'}>Draft</Select.Option>
        <Select.Option value={'revised'}>Revised</Select.Option>
        <Select.Option value={'expired'}>Expired</Select.Option>
        <Select.Option value={true}>Active</Select.Option>
        <Select.Option value={false}>None Active</Select.Option>
      </Select>
    ),
  },
  // {
  //   Header: 'Issued',
  //   accessor: 'issuance.issued',
  //   width: 150,
  //   Cell: IssuedStatusCell,
  // },
  // {
  //   Header: 'File',
  //   accessor: 'file',
  //   width: 150,
  //   Cell: FileCell,
  // },
]

function QuotesList(props) {
  const {
    fetching,
    fetch,
    tableRef,
    list,
    onChangeCompany,
    company,
    toggleSelection,
    toggleAll,
    selectAll,
    selection,
    isSelected,
    filterable,
    fetchingEmailTemplate,
    showEmail,
    visibleEmail,
    onCancelEmail,
    emailTemplate,
    emailDetails,
    emailFiles,
    emailLines,
    hideCompany,
    enquiryID,
  } = props
  const checkboxProps = {
    selectType: 'checkbox',
    toggleSelection,
    isSelected,
    toggleAll,
    selectAll,
    selection,
  }

  const NewButton = withRouter(({ history, ...rest }) => {
    return (
      <Button
        type="primary"
        icon={'plus'}
        size={'small'}
        onClick={() => {
          history.push({
            pathname: '/clients/quotes/new/',
            search: formatQueryParams('enquiryID', enquiryID, true),
          })
        }}
        {...rest}>
        New Quote
      </Button>
    )
  })

  React.useEffect(() => {
    fetch()
  }, [])
  return (
    <Fragment>
      <EmailCont
        key={ids.next().value}
        visible={visibleEmail}
        onCancel={onCancelEmail}
        template={emailTemplate}
        email={emailDetails}
        files={emailFiles}
        lines={emailLines}
      />
      <CheckboxTable
        {...checkboxProps}
        CreateButton={() => <NewButton style={{ marginRight: 10 }} />}
        ExtraButtons={() => (
          <Fragment>
            <Button
              size={'small'}
              icon={'mail'}
              loading={fetchingEmailTemplate}
              onClick={showEmail}
              disabled={selection.length === 0}>
              Email Issuance
            </Button>
          </Fragment>
        )}
        ExtraOptionsButtons={() =>
          hideCompany !== true && (
            <OrganisationsSelect
              onChange={onChangeCompany}
              value={company}
              placeholder={'Filter by a company'}
              size={'small'}
              style={{ width: '450px', paddingRight: 20, float: 'right' }}
            />
          )
        }
        fetch={fetch}
        ref={tableRef}
        columns={columns}
        data={list}
        fetching={fetching}
        withRef={tableRef}
        isFilterable={filterable}
        defaultPageSize={20}
        show={{ extraColumns: true }}
        defaultFiltered={[
          {
            id: 'status',
            value: true,
          },
        ]}
      />
    </Fragment>
  )
}

QuotesList.propTypes = {}
QuotesList.defaultProps = {
  fetching: false,
  fetch: () => console.error('Not Implemented'),
  list: [],
  selection: [],
}

export default compose(withState('filterable', 'setFilterable', true))(QuotesList)
